import { useFontScale, type FontScale } from '../../hooks/useFontScale';

const STEPS: { scale: FontScale; label: string; sizeClass: string }[] = [
  { scale: 'normal', label: 'Normal text size', sizeClass: 'text-xs' },
  { scale: 'large', label: 'Large text size', sizeClass: 'text-sm' },
  { scale: 'larger', label: 'Largest text size', sizeClass: 'text-base' },
];

/**
 * Accessibility: a three-step text-size control. Each button shows an "A" at
 * its size so the choice is self-describing. Scales the whole app via the root
 * font-size (see useFontScale).
 */
export function FontSizeControl() {
  const { scale, setScale } = useFontScale();
  return (
    <div
      role="radiogroup"
      aria-label="Text size"
      className="inline-flex items-center gap-0.5 rounded-token-sm border border-line-strong/15 bg-surface p-0.5"
    >
      {STEPS.map((step) => {
        const selected = scale === step.scale;
        return (
          <button
            key={step.scale}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-label={step.label}
            title={step.label}
            onClick={() => setScale(step.scale)}
            className={`flex h-7 w-7 items-center justify-center rounded-[6px] font-semibold leading-none transition-colors ${step.sizeClass} ${
              selected ? 'bg-accent text-fg-on-accent' : 'text-fg-muted hover:bg-surface-2'
            }`}
          >
            A
          </button>
        );
      })}
    </div>
  );
}
